import { hbdTrackEvent } from "../modules/hbdTrackEvent";

export class OverlayMapControl {
    _map;
    _container;
    locationHTMLnoText =
        '<button class="mapboxgl-ctrl-icon mapboxgl-ctrl-overlay" type="button" data-toggle="modal" data-target="#overlayMapModal" aria-label="Toggle bigger view"></button>';
    locationHTMLwithText =
        '<button class="mapboxgl-ctrl-icon mapbox-ctrl-text mapboxgl-ctrl-overlay" type="button" data-toggle="modal" data-target="#overlayMapModal" aria-label="Toggle bigger view"><span class="d-none d-md-block medium">Karte vergrößern</span></button>';
    tracking = "";

    constructor(tracking) {
        this.tracking = tracking;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className =
            "mapboxgl-ctrl mapboxgl-ctrl-group toGroup d-block";
        if ($(this._map._container).data("overlay-text")) {
            this._container.innerHTML = this.locationHTMLwithText;
        } else {
            this._container.innerHTML = this.locationHTMLnoText;
        }
        this._container.addEventListener("click", () => {
            hbdTrackEvent("show map", "click", this.tracking);
        });
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}

export class OverlayCloseMapControl {
    _map;
    _container;
    locationHTML =
        '<button class="mapboxgl-ctrl-icon mapbox-ctrl-text mapboxgl-ctrl-close" type="button" class="close" data-dismiss="modal" aria-label="Close"><span class="d-none d-md-block medium">Karte schließen</span></button>';

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className =
            "mapboxgl-ctrl mapboxgl-ctrl-group toGroup d-block";
        this._container.innerHTML = this.locationHTML;
        this._container.addEventListener("click", () => {
            let shrink = document.querySelector(".mapboxgl-ctrl-shrink");
            if (shrink) {
                shrink.click();
            }
        });
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}